import React from "react"
import Popup from "../Popup/Popup"
import EmailMfaOtpChallenge from "./EmailMfaOtpChallenge"
import styles from "./EmailMfaOtpModal.module.scss"

const EmailMfaOtpModal = ({
  isOpen,
  title,
  description,
  otp,
  onOtpChange,
  error,
  busy = false,
  onCancel,
  onConfirm,
  mode,
  onSendSms,
  smsBusy = false,
  smsMessage = "",
}) => {
  const otpInputRef = React.useRef(null)

  React.useEffect(() => {
    if (!isOpen) return undefined
    const timer = window.setTimeout(() => {
      if (otpInputRef.current) {
        otpInputRef.current.focus({ preventScroll: true })
      }
    }, 100)
    return () => window.clearTimeout(timer)
  }, [isOpen])

  if (!isOpen) return null

  return (
    <Popup
      width={520}
      title="Email MFA Verification"
      isCrossIcon
      closeAction={onCancel}
      closeByOutsideClick={!busy}
      className={styles.modal}
    >
      <EmailMfaOtpChallenge
        variant="modal"
        mode={mode}
        title={title}
        description={description}
        otp={otp}
        onOtpChange={onOtpChange}
        error={error}
        busy={busy}
        onCancel={onCancel}
        onConfirm={onConfirm}
        otpInputRef={otpInputRef}
        onSendSms={onSendSms}
        smsBusy={smsBusy}
        smsMessage={smsMessage}
      />
    </Popup>
  )
}

export default EmailMfaOtpModal
